export default __webpack_public_path__ + "static/media/promocionAlarma6Mobile.7b4e3284.png";